const DueDateOptionValues = {
  DueDate: 1,
  ExtendedDueDate: 2,
  SecondExtendedDueDate: 3,
};

module.exports = { DueDateOptionValues };
